import SplitscreenGrid from "../splitscreenGrid";
import GridItem from "../gridItem";
import NarrowcastingView from "../narrowcastingView";

export default function TSplitScreenRight() {
    return (
        <SplitscreenGrid columns='2' rows='4'>
            <GridItem column = '1' row = 'span 2'>
                <NarrowcastingView screen={1}/>
            </GridItem>
            <GridItem column = '1' row = 'span 2'>
                <NarrowcastingView screen={2}/>
            </GridItem>
            <GridItem column = '2' row = '1/5'>
                <NarrowcastingView screen={0}/>
            </GridItem>
        </SplitscreenGrid>
    )
}